// Under `/auth/*`, which already runs the Worker first.
export const RENEW_PATH = "/auth/reader-renew";
export const RENEW_COMMIT_PATH = "/auth/reader-renew/commit";
